export const disabledItem = (icon: string) => {
  return {
    border: "1px solid black",
    borderTop: "none",
    backgroundImage:
      " linear-gradient(to bottom, rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(\n" +
      icon +
      "\n)",

    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    minHeight: 150,
    backgroundPosition: "center",
    position: "relative",
  };
};

export const disabledItemBG = (icon: string) => {
  return {
    border: "1px solid black",
    borderTop: "none",
    backgroundImage:
      " linear-gradient(to bottom, rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(\n" +
      icon +
      "\n)",

    backgroundSize: "cover",
    minHeight: 150,
    backgroundPosition: "center",
    position: "absolute",
    zIndex: -1,
    filter: "blur(5px)",
  };
};

export const activeItem = (icon: string) => {
  return {
    border: "1px solid black",
    borderTop: "none",
    height: 150,
    backgroundSize: "cover",
    backgroundImage: 'url("' + icon + '")',
    backgroundPosition: "center center",
  };
};
export const activeItemBG = (icon: string) => {
  return {
    width: "100%",
    border: "1px solid black",
    borderTop: "none",
    backgroundImage: 'url("' + icon + '")',
    backgroundSize: "cover",
    minHeight: 150,
    backgroundPosition: "center",
    position: "absolute",
    zIndex: -1,
    filter: "blur(5px)",
  };
};
